export default "__VITE_ASSET__Bny2OfTQ__"